import { aggregateTimeSeriesPoints } from '@/features/charts/lib/aggregateTimeSeriesPoints';
import type { TimeSeriesPoint } from '@/features/charts/lib/buildChartLineSeries';
import { buildChartLineSeries } from '@/features/charts/lib/buildChartLineSeries';
import { getFieldDecimalPlaces } from '@/features/charts/lib/getFieldDecimalPlaces';
import { getSeriesId } from '@/features/charts/lib/getSeriesId';
import { getSeriesName } from '@/features/charts/lib/getSeriesName';
import type {
  KeyData,
  SeriesData,
  SeriesMetadata,
  SeriesRecord
} from '@/features/charts/types/chartData';

type ParseableElements = {
  symbolIndex: number;
  shortTitle: string | undefined;
  key: KeyData;
  metadata: SeriesMetadata;
  transactionDate: string | undefined;
  color?: string;
};
export const parseDataToChartSeries = (
  series: SeriesData,
  parseableElements: ParseableElements,
  isDhChartFullscreen: boolean,
  seriesDataAggregator: (tsData: SeriesRecord, decimalPlaces: number) => TimeSeriesPoint
) => {
  const { symbolIndex, shortTitle, key, metadata, transactionDate, color } = parseableElements;
  return Object.keys(series).map((field: string, fieldIndex) => {
    const combinedIndex = symbolIndex * Object.keys(series).length + fieldIndex;
    const fieldValue = series[field];
    const decimalPlaces = getFieldDecimalPlaces(fieldValue);

    const name = isDhChartFullscreen
      ? metadata.Alias || key.Code
      : getSeriesName(shortTitle, metadata.Title, transactionDate);
    const id = getSeriesId(key, field, transactionDate);
    const timeSeriesPoints = aggregateTimeSeriesPoints({
      series,
      field,
      decimalPlaces,
      seriesDataAggregator
    });
    return buildChartLineSeries({
      id,
      name,
      color,
      timeSeriesPoints,
      context: {
        ...key,
        ...metadata,
        decimalPlaces,
        combinedIndex,
        transactionDate,
        field,
        color
      },
      isDaily: 'Prompt' === key.PeriodType
    });
  });
};
